import "@mdi/font/css/materialdesignicons.css"
import Vue from "vue"
import Vuetify from "vuetify/lib"
import { Ripple } from 'vuetify/lib/directives';

Vue.use(Vuetify, {
  directives: {
    Ripple,
  },
})

export default new Vuetify({
  icons: {
    iconfont: "mdi"
  },
  theme: {
    dark: false,
    themes: {
      light: {
        // MAIN
        primary: "#3071A9",
        secondary: "#E9ECEF",
        accent: "#493D55",
        error: "#e05d6f",
        warning: "#f0ad4e",
        info: "#5bc0de",
        success: "#5cb85c",

        // CUSTOM
        button: "#17A2B8",
        button_text: "#fff"
      },
      dark: {
        // MAIN
        primary: "#3071A9",
        secondary: "#E9ECEF",
        accent: "#493D55",
        error: "#e05d6f",
        warning: "#f0ad4e",
        info: "#5bc0de",
        success: "#5cb85c",

        // CUSTOM
        button: "#17A2B8",
        button_text: "#fff"
      }
    },
    options: {
      customProperties: true
    }
  }
})
